import { Divider, Icon, List, ListItem, Typography } from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import Drawer from "@material-ui/core/Drawer";
import { withStyles } from "@material-ui/core/styles";
import DOMPurify from "dompurify";
import _ from "lodash";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Collapsible from "react-collapsible";
import { connect } from "react-redux";

import { mapActionsToProps } from "./../redux/miniCrm/article";

const drawerWidth = 400;

const styles = (theme) => ({
  root: {
    display: "flex",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      width: 200,
    },
  },
  drawerPaper: {
    width: drawerWidth,
    [theme.breakpoints.down("sm")]: {
      width: 200,
    },
    left: "auto",
    top: "auto",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
  },
  toolbar: theme.mixins.toolbar,
});
class Topic extends Component {
  state = {
    view: {},
    open: "",
    expanded: "",
    viewArticleSearch: {},
    checkArticle: true,
    submitTag: false,
    viewArticle: {},
    countTopic: 0,
    countChip: 0,
    countSearchTopic: null,
  };
  static getDerivedStateFromProps(props, state) {
    if (props.countSearchTopic !== state.countSearchTopic) {
      return {
        countChip: 0,
        countSearchTopic: props.countSearchTopic,
      };
    }
    if (props.submitTag) {
      return {
        viewArticleSearch: {},
      };
    }
    if (
      props.article &&
      Object.keys(props.article).length &&
      JSON.stringify(props.article) !== JSON.stringify(state.viewArticle)
    ) {
      return {
        viewArticle: props.article,
      };
    }
    if (
      Object.keys(props.selectedItem).length &&
      JSON.stringify(props.selectedItem) !== JSON.stringify(state.viewArticle)
    ) {
      props.openAArticle(props.selectedItem.id);
      return {
        viewArticle: props.selectedItem,
        view: props.selectedItem,
        checkArticle: props.openSearch,
      };
    }
    return null;
  }
  renderViewArticla = (item) => {
    this.setState({
      view: item,
    });
  };
  renderViewArticleSearch = (item) => {
    this.props.changeSubmitTag();
    this.setState({
      viewArticleSearch: item,
      countTopic: 1,
    });
  };

  handleChange = (panel) => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : !expanded,
    });
  };

  print = (items, level) => {
    const { expanded } = this.state;
    if (items.length > 0) {
      return (
        <ul style={{ display: "inline-block", padding: 0 }}>
          {items.map((item, key) => {
            let prefix = 0;
            for (let i = 0; i <= level; i++) {
              prefix += 1;
            }
            // if (item && item.children && item.children.length > 0) {
            //     this.print(item.children, level + 1);
            // };
            // console.log("|" + prefix + " Folder:", item.title);
            return (
              <React.Fragment>
                <li>
                  <Collapsible
                    trigger={
                      <div
                        className="node"
                        style={{
                          alignItems: "center",
                          display: "flex",
                          color: "#000",
                        }}>
                        <Icon fontSize="small">folder_open</Icon>
                        <Typography style={{ marginLeft: 10 }}>
                          {item.title}{" "}
                          {item.children.length == 0
                            ? `(${item.articles.length})`
                            : `(${
                                item.children.length + item.articles.length
                              })`}
                        </Typography>
                      </div>
                    }
                    transitionTime={200}>
                    {item.articles.map((article) => {
                      // console.log("|" + prefix + "- Article:", article.title);
                      return (
                        <li
                          onClick={() => {
                            this.renderViewArticla(article);
                            this.props.openAArticle(article.id);
                            this.setState({
                              checkArticle: this.props.openSearch,
                            });
                            this.props.changeSelectedItem({});
                          }}>
                          <div
                            className="node"
                            style={{
                              alignItems: "center",
                              display: "flex",
                              color: "#000",
                            }}>
                            <Icon fontSize="small">insert_drive_file</Icon>
                            <Typography style={{ marginLeft: 10 }}>
                              {article.title}
                            </Typography>
                            {this.state.view.id == article.id ? (
                              <Icon
                                fontSize="small"
                                style={{ marginLeft: 10, color: "#fcb71e" }}>
                                control_camera
                              </Icon>
                            ) : (
                              <React.Fragment />
                            )}
                          </div>
                        </li>
                      );
                    })}
                    {this.print(item.children, level + 1)}
                  </Collapsible>
                </li>
              </React.Fragment>
            );
          })}
        </ul>
      );
    }
  };

  stripScripts = (s, tag) => {
    const div = document.createElement("div");
    div.innerHTML = DOMPurify.sanitize(s);
    const scripts = div.getElementsByTagName(tag);
    let i = scripts.length;
    while (i--) {
      scripts[i].parentNode.removeChild(scripts[i]);
    }
    return div.innerHTML;
  };

  formatHtml = (type) => {
    const element =
      type === "search-topic"
        ? document.getElementById(type)
        : document.getElementsByClassName("search-chip");
    if (type === "search-topic") {
      this.getTextNodesIn(element, (textNode, parent) => {
        const reg = new RegExp(this.props.keyword, "ig");
        if (this.getText(textNode).match(reg) && parent.tagName !== "MARK") {
          parent.innerHTML = DOMPurify.sanitize(
            this.getText(textNode).replace(
              new RegExp(this.props.keyword, "ig"),
              `<mark>$&</mark>`
            )
          );
        }
        if (/^\s+$/.test(textNode.nodeValue)) {
          parent.removeChild(textNode);
        }
      });
    } else {
      for (let i = 0; i < element.length; i++) {
        this.getTextNodesIn(element[i], (textNode, parent) => {
          const reg = new RegExp(this.props.keyword, "ig");
          if (this.getText(textNode).match(reg) && parent.tagName !== "MARK") {
            parent.innerHTML = DOMPurify.sanitize(
              this.getText(textNode).replace(
                new RegExp(this.props.keyword, "ig"),
                `<mark>$&</mark>`
              )
            );
          }
          if (/^\s+$/.test(textNode.nodeValue)) {
            parent.removeChild(textNode);
          }
        });
      }
    }
    this.setState({
      [type === "search-topic" ? "countTopic" : "countChip"]:
        type === "search-topic"
          ? this.state.countTopic + 1
          : this.state.countChip + 1,
    });
  };

  getTextNodesIn = (elem, opt_fnFilter) => {
    let textNodes = [];
    if (elem) {
      for (let nodes = elem.childNodes, i = nodes.length; i--; ) {
        let node = nodes[i],
          nodeType = node ? node.nodeType : null;
        if (nodeType == 3) {
          if (!opt_fnFilter || opt_fnFilter(node, elem)) {
            textNodes.push(node);
          }
        } else if (nodeType == 1 || nodeType == 9 || nodeType == 11) {
          textNodes = textNodes.concat(this.getTextNodesIn(node, opt_fnFilter));
        }
      }
    }
    return textNodes;
  };

  getText = (obj) => {
    return obj.textContent ? obj.textContent : obj.innerText;
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}>
          <React.Fragment>
            {this.props.search}
            {this.props.openSearch == true ? (
              Array.isArray(this.props.listSearchArticle) &&
              this.props.listSearchArticle.length != 0 ? (
                <List dense={false}>
                  {this.props.listSearchArticle.map((item, key) => {
                    return (
                      <>
                        <ListItem
                          button={true}
                          key={key}
                          onClick={() => this.renderViewArticleSearch(item)}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}>
                            <h3
                              dangerouslySetInnerHTML={{
                                __html: this.stripScripts(
                                  item.title ? item.title : "",
                                  "style"
                                ),
                              }}></h3>
                            <i
                              dangerouslySetInnerHTML={{
                                __html: this.stripScripts(
                                  item.description ? item.description : "",
                                  "style"
                                ),
                              }}></i>
                            <div>
                              {item.resultTags &&
                                item.resultTags.length &&
                                item.resultTags.map((item) => {
                                  return (
                                    <Chip label={item} className="search-chip">
                                      {this.state.countChip < 3 &&
                                        this.formatHtml("search-chip")}
                                    </Chip>
                                  );
                                })}
                            </div>
                            <small
                              dangerouslySetInnerHTML={{
                                __html: this.stripScripts(
                                  item.subMarkContent
                                    ? item.subMarkContent
                                    : "",
                                  "style"
                                ),
                              }}></small>
                          </div>
                        </ListItem>
                        <Divider style={{ margin: "5px 0 10px 0" }} />
                      </>
                    );
                  })}
                </List>
              ) : (
                <Typography style={{ marginLeft: 10 }}>
                  Chưa có dữ liệu
                </Typography>
              )
            ) : (
              <div className="tree" style={{ paddingRight: 10 }}>
                {this.print(this.props.treeData, 0)}
              </div>
            )}
          </React.Fragment>
        </Drawer>
        <div className={classes.toolbar} />
        <Divider />
        <main
          className={classes.content}
          style={{
            width: "100%",
            overflow: "scroll",
            overflowX: "hidden",
          }}>
          <div style={{ marginLeft: 10 }}>
            {this.props.openSearch !== true ? (
              !!this.state.viewArticle &&
              Object.keys(this.state.viewArticle).length ? (
                this.state.viewArticle.id == this.state.view.id ? (
                  <div style={{ width: "100%" }}>
                    <h3
                      dangerouslySetInnerHTML={{
                        __html: this.stripScripts(
                          this.state.viewArticle.title
                            ? this.state.viewArticle.title
                            : "",
                          "style"
                        ),
                      }}
                      style={{ lineHeight: "1.5", color: "##1e90ff" }}
                      className="render-html"></h3>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: this.stripScripts(
                          this.state.viewArticle.description
                            ? this.state.viewArticle.description
                            : "",
                          "style"
                        ),
                      }}
                      style={{ lineHeight: "1.5", fontStyle: "italic" }}
                      className="render-html"></div>
                    <Divider />
                    <div
                      dangerouslySetInnerHTML={{
                        __html: this.stripScripts(
                          this.state.viewArticle.content
                            ? this.state.viewArticle.content
                            : "",
                          "style"
                        ),
                      }}
                      style={{ lineHeight: "1.5", marginTop: 15 }}
                      className="render-html"></div>
                    <Typography
                      variant="title"
                      style={{
                        alignItems: "center",
                        width: "100%",
                        lineHeight: 3,
                      }}>
                      Tags:
                      {this.state.viewArticle.tags &&
                      this.state.viewArticle.tags.length != 0 &&
                      this.state.viewArticle.tags.length !== undefined
                        ? this.state.viewArticle.tags.map((i) => {
                            return <Chip label={i} className={classes.chip} />;
                          })
                        : ""}
                    </Typography>
                  </div>
                ) : (
                  <Typography style={{ marginLeft: 10 }}>
                    Chưa có dữ liệu
                  </Typography>
                )
              ) : (
                <Typography style={{ marginLeft: 10 }}>
                  Chưa có dữ liệu
                </Typography>
              )
            ) : _.isEmpty(this.state.viewArticleSearch) ? (
              <Typography style={{ marginLeft: 10 }}>
                Chưa có dữ liệu
              </Typography>
            ) : (
              <div style={{ width: "100%" }} id="search-topic">
                <h2
                  dangerouslySetInnerHTML={{
                    __html: this.stripScripts(
                      this.state.viewArticleSearch.title
                        ? this.state.viewArticleSearch.title
                        : "",
                      "style"
                    ),
                  }}
                  style={{ lineHeight: "1.5" }}
                  className="render-html"></h2>
                <div
                  dangerouslySetInnerHTML={{
                    __html: this.stripScripts(
                      this.state.viewArticleSearch.description
                        ? this.state.viewArticleSearch.description
                        : "",
                      "style"
                    ),
                  }}
                  style={{ lineHeight: "1.5", fontStyle: "italic" }}
                  className="render-html"></div>
                <Divider />
                <div
                  dangerouslySetInnerHTML={{
                    __html: this.stripScripts(
                      this.state.viewArticleSearch.content
                        ? this.state.viewArticleSearch.content
                        : "",
                      "style"
                    ),
                  }}
                  style={{ lineHeight: "1.5", marginTop: 15 }}
                  className="render-html"></div>
                <Typography
                  variant="title"
                  style={{
                    alignItems: "center",
                    width: "100%",
                    lineHeight: 3,
                  }}>
                  <span>Tags:</span>
                  {this.state.viewArticleSearch.tags.length != 0
                    ? this.state.viewArticleSearch.tags.map((i) => {
                        return <Chip label={i} className={classes.chip} />;
                      })
                    : ""}
                </Typography>
                {this.state.countTopic < 3 && this.formatHtml("search-topic")}
              </div>
            )}
          </div>
        </main>
      </div>
    );
  }
}

Topic.propTypes = {
  classes: PropTypes.object.isRequired,
  treeData: PropTypes.array,
  listSearchArticle: PropTypes.array,
  search: PropTypes.func,
  openSearch: PropTypes.bool,
  submitTag: PropTypes.bool,
  changeSubmitTag: PropTypes.func,
};

Topic.defaultProps = {
  treeData: [],
  listSearchArticle: [],
  openSearch: true,
  submitTag: false,
};

const mapStateToProps = (state) => ({
  article: state.article.article,
  keyword: state.article.keyword,
});

Topic = connect(mapStateToProps, mapActionsToProps)(Topic);
export default withStyles(styles)(Topic);
